export { default } from './TextLabel';
export * from './TextLabel';
